import { LayerManagerLayer } from '../types.js';
import { Animations } from '../Animations.js';
import { OrderedLayers, LayerContextType } from '../constants.js';
import { useMediaQuery } from '@doordash/utilities';
import React from 'react';
import renderOnLayer from '../renderOnLayer.js';
import styled from 'styled-components';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var AnchoredLayerContentContainer = styled.div.withConfig({
  displayName: "AnchoredLayerContainer__AnchoredLayerContentContainer",
  componentId: "sc-1xurd03-0"
})(["will-change:transform;transition:opacity 300ms ease-in-out;top:0;left:0;"]);
var AnchoredLayerContent = function AnchoredLayerContent(_ref) {
  var inProp = _ref["in"],
      containerWidth = _ref.containerWidth,
      animationOptions = _ref.animationOptions,
      onExited = _ref.onExited,
      innerRef = _ref.innerRef,
      cssPosition = _ref.cssPosition,
      transform = _ref.transform,
      style = _ref.style,
      children = _ref.children,
      hidden = _ref.hidden;
      _ref.enter;
      _ref.exit;
      var _ref$customAnimation = _ref.customAnimation,
      customAnimation = _ref$customAnimation === void 0 ? Animations.Slide : _ref$customAnimation;
      _ref.appear;
      var props = _objectWithoutProperties(_ref, ["in", "containerWidth", "animationOptions", "onExited", "innerRef", "cssPosition", "transform", "style", "children", "hidden", "enter", "exit", "customAnimation", "appear"]);

  var prefersReducedMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  var Animation = typeof customAnimation === 'string' || prefersReducedMotion ? Animations.None : customAnimation;
  return /*#__PURE__*/React.createElement(AnchoredLayerContentContainer, _extends({
    ref: innerRef,
    style: _objectSpread(_objectSpread({}, style), {}, {
      width: typeof containerWidth !== 'undefined' ? "".concat(containerWidth, "px") : undefined,
      position: cssPosition,
      transform: transform,
      // if the element is hidden,
      // make it hidden visibly with
      // opacity, and prevent interaction
      // via pointer-events: none
      opacity: hidden ? 0 : 1,
      pointerEvents: hidden ? 'none' : 'auto'
    })
  }, props), /*#__PURE__*/React.createElement(Animation, {
    component: "div",
    "in": inProp,
    onExited: onExited,
    animationOptions: animationOptions
  }, children));
};

var renderOnLayerWithOptions = function renderOnLayerWithOptions(layer) {
  return renderOnLayer(layer, AnchoredLayerContent, {
    AnimationType: Animations.Custom
  });
};

var LayerContentOverContent = renderOnLayerWithOptions(LayerManagerLayer.PopoverContent);
LayerContentOverContent.displayName = 'LayerContentOverContent';
var LayerContentOverPopoverContent = renderOnLayerWithOptions(LayerManagerLayer.Sheet);
LayerContentOverPopoverContent.displayName = 'LayerContentOverPopoverContent';
var LayerContentOverSheet = renderOnLayerWithOptions(LayerManagerLayer.Modal);
LayerContentOverSheet.displayName = 'LayerContentOverSheet';
var LayerContentOverModal = renderOnLayerWithOptions(LayerManagerLayer.PopoverModal);
LayerContentOverModal.displayName = 'LayerContentOverModal';

var AnchoredLayerContainer = function AnchoredLayerContainer(_ref2, context) {
  var initialDirection = _ref2.initialDirection,
      customAnimation = _ref2.animation,
      innerRef = _ref2.innerRef,
      props = _objectWithoutProperties(_ref2, ["initialDirection", "animation", "innerRef"]);

  var orderedLayerIndex = OrderedLayers.indexOf(context.currentLayerContext); // This removes the Node from the TransitionGroup
  // and is needed to ensure the content animates out

  if (props.children) {
    switch (context.currentLayerContext) {
      case LayerManagerLayer.PopoverContent:
        return /*#__PURE__*/React.createElement(LayerContentOverPopoverContent, _extends({}, props, {
          innerRef: innerRef,
          customAnimation: customAnimation,
          animationOptions: {
            direction: initialDirection,
            enterDuration: 100
          }
        }));

      case LayerManagerLayer.Sheet:
        return /*#__PURE__*/React.createElement(LayerContentOverSheet, _extends({}, props, {
          innerRef: innerRef,
          customAnimation: customAnimation,
          animationOptions: {
            direction: initialDirection,
            enterDuration: 100
          }
        }));

      case LayerManagerLayer.Modal:
        return /*#__PURE__*/React.createElement(LayerContentOverModal, _extends({}, props, {
          innerRef: innerRef,
          customAnimation: customAnimation,
          animationOptions: {
            direction: initialDirection,
            enterDuration: 100
          }
        }));

      default:
        if (orderedLayerIndex >= OrderedLayers.length - 1) {
          // Render the children on the top-most Layer if content
          // is on the top-most Layer
          return /*#__PURE__*/React.createElement(LayerContentOverModal, _extends({}, props, {
            innerRef: innerRef,
            customAnimation: customAnimation,
            animationOptions: {
              direction: initialDirection,
              enterDuration: 100
            }
          }));
        } // Default to the lowest Layer


        return /*#__PURE__*/React.createElement(LayerContentOverContent, _extends({}, props, {
          innerRef: innerRef,
          customAnimation: customAnimation,
          animationOptions: {
            direction: initialDirection,
            enterDuration: 100
          }
        }));
    }
  }

  return null;
};

AnchoredLayerContainer.contextTypes = {
  currentLayerContext: LayerContextType
};

export { AnchoredLayerContent, AnchoredLayerContainer as default };
